import { useSelector } from 'react-redux';
import { RootState } from '../store';
import * as PlansUtils from '../utils/PlansUtils';
import { useCustomerSubscription } from './useCustomerSubscription';

export const usePlanStatus = () => {
  const isClient = useSelector((state: RootState) => state.user.isClient);

  const {
    stripeCustomer,
    allSubscriptions,
    customerSubscription,
  } = useCustomerSubscription();

  const planStatus: {
    isProPlan: boolean;
    isBasicPlan: boolean;
    isFixedAccessProPlan: boolean;
    isFixedAccessBasicPlan: boolean;
    isTrialing: boolean;
    isTrialPeriodExpired: boolean;
    requireProUpgrade: boolean;
    isPaidPlan: boolean;
    isCancelledPlan: boolean;
    billingCycle: string | undefined;
  } = {
    isProPlan: false,
    isBasicPlan: false,
    isFixedAccessProPlan: false,
    isFixedAccessBasicPlan: false,
    // isTrialing indicates if at current moment user is on trial or not
    isTrialing: false,
    requireProUpgrade: false,
    // isTrialPeriodExpired indicates if trial got expired or not
    // is true even if user is on paid plan but the initial offered trial got expired
    isTrialPeriodExpired: false,
    // isCancelledPlan indicates if paid subscription is cancelled because of any reason (manual cancellation or non-payment)
    isCancelledPlan: false,
    // isPaidPlan user has an active subscription and not currently trialing
    isPaidPlan: false,
    billingCycle: undefined,
  };

  if (stripeCustomer && !isClient) {
    planStatus.isTrialing = PlansUtils.hasActiveTrial(allSubscriptions);
    planStatus.isTrialPeriodExpired = PlansUtils.isTrialPeriodExpired(
      allSubscriptions,
    );

    // isCancelledPlan indicates if subscription is cancelled because of any reason
    planStatus.isCancelledPlan =
      PlansUtils.hasCancelledPlan(allSubscriptions) && !customerSubscription;

    const activeSubscriptionPlanPrice =
      customerSubscription?.items?.data[0].price;

    planStatus.billingCycle = PlansUtils.getBillingCycle(
      activeSubscriptionPlanPrice,
    );
    planStatus.isProPlan =
      PlansUtils.isProPlan(activeSubscriptionPlanPrice) &&
      !planStatus.isCancelledPlan;
    planStatus.isBasicPlan =
      PlansUtils.isBasicPlan(activeSubscriptionPlanPrice) &&
      !planStatus.isCancelledPlan;
    planStatus.isFixedAccessBasicPlan = PlansUtils.isFixedAccessBasicPlan(
      activeSubscriptionPlanPrice,
    );
    planStatus.isFixedAccessProPlan = PlansUtils.isFixedAccessProPlan(
      activeSubscriptionPlanPrice,
    );

    // TODO: Add Copilot Starter to this check behind the flag `EnableNewPricingPlans`
    planStatus.requireProUpgrade =
      planStatus.isTrialing || planStatus.isBasicPlan;

    planStatus.isPaidPlan =
      planStatus.isProPlan ||
      planStatus.isBasicPlan ||
      planStatus.isFixedAccessBasicPlan ||
      planStatus.isFixedAccessProPlan;
  }

  return { ...planStatus };
};
